<template>
  <div id="header" :class="{select: fixedMenu}">
      <div class="header__margin">
           <div v-show="!view_seacrh_bl" @click="categoryMenuMobile" class="header_catalog">
                <span class="mdi mdi-menu"></span>
                <p>
                    Каталог товаров
                </p>
           </div>
           <div v-show="!view_seacrh_bl" class="header__margin__r">
                    <div class="header__r__m__user">
                        <div class="h__r__m__u__b" @click="view_seacrh_block">
                                <span class="mdi mdi-magnify"></span>
                        </div>
                        <router-link to="/favorite">
                                <div class="h__r__m__u__b">
                                    <span class="mdi mdi-cards-heart"></span>
                                    <div v-if="FAVORITE.length != 0" class="product__length">
                                        {{FAVORITE.length}}
                                    </div>
                                </div>
                        </router-link>
                        
                        <div v-if="USER.length == 0" class="h__r__m__u__b" @click="openForm">
                                <span class="mdi mdi-account"></span>
                        </div>
                        
                        <router-link to="/profile">
                            <div v-if="USER.length != 0" class="h__r__m__u__b">
                                        <span class="mdi mdi-account"></span>
                                </div>
                        </router-link>

                        <router-link to="/basket">
                            <div class="h__r__m__u__b">
                                    <span class="mdi mdi-basket-outline"></span>
                                    <div v-if="CART.length != 0" class="product__length">
                                        {{CART.length}}
                                    </div>
                                </div>
                        </router-link>
                    </div>
          </div>
          <div v-show="view_seacrh_bl" class="search_view">
                <SeacrhM @closeInput="closeInput" />
          </div>
          <div v-show="categoryShow" class="menu_fixed_category">
              <div class="menu_fixed_category_scroll">
                  <div class="menu_fixed_category_header">
                            <button @click="closeCatMob">
                                <span class="mdi mdi-arrow-left-bold"></span>
                            </button>
                            <p>
                                Категории
                            </p>
                        </div>
                        <v-row justify="center">
                            <v-expansion-panels accordion>
                            <v-expansion-panel
                                v-for="categoryId in category"
                                :key="categoryId.id"
                            >
                                <v-expansion-panel-header @click="clickGetCategory(categoryId.id)">
                                    <div @click="categoryIdOpen(categoryId.id)" class="cat_title_cl">
                                        {{categoryId.name}}
                                    </div>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <!-- ----------------------------- -->
                                    
                                    <v-expansion-panels accordion>
                                        <v-expansion-panel
                                            v-for="subcategoryId in subcategory"
                                            :key="subcategoryId.id"
                                        >   
                                            <v-expansion-panel-header @click="clickGetCategorySub(subcategoryId.id)">
                                                <div @click="categoryIdOpen(subcategoryId.id)" class="cat_title_cl">
                                                    {{subcategoryId.name}}
                                                </div>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <div 
                                                    class="mob_accordion_list"
                                                    v-for="subcategory_subId in subcategory_sub"
                                                    :key="subcategory_subId.id"
                                                    @click="categoryIdOpen(subcategory_subId.id)"
                                                >
                                                    <p>{{subcategory_subId.name}}</p>
                                                </div>
                                            </v-expansion-panel-content>
                                        </v-expansion-panel>
                                    </v-expansion-panels>


                                    <!-- ----------------------------- -->
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                            </v-expansion-panels>
                        </v-row>
              </div>
              
          </div>
      </div>
  </div>
</template>
<script>
import SeacrhM from '@/components/mobile/SeacrhM';
import {mapGetters} from 'vuex'

export default {
  name: 'HeaderMob',
  data() {
    return {
      limitPosition: 85,
      fixedMenu: false,
      category: [],
      subcategory: [],
      subcategoryMain: [],
      view_seacrh_bl: false,
      categoryShow: false,
      subcategory_sub: [],
    };
  },
  components: {
      SeacrhM
  },
  methods: {
    openForm() {
        this.$emit('openForm')
        document.querySelector('.modal').style.display = 'block'
    },
    categoryMenuMobile() {
        this.categoryShow = true
    },
    handleScroll() {
      if (window.scrollY > this.limitPosition) {
        this.fixedMenu = true
      } else {
        this.fixedMenu = false
      }
    },
    closeCatMob() {
        this.categoryShow = false
    },
    closeInput() {
        this.view_seacrh_bl = false
    },
    getCategory() {
            fetch(this.$apiURI + 'public/category/getall')
            .then((res) => {
                res.json().then((data) => {
                    let filterCategory = data.filter((item) => item.parent_id == 0)
                    let filterSubCategory = data.filter((item) => item.parent_id != 0)
                    this.category = filterCategory
                    this.subcategoryMain = filterSubCategory
                });
            })
    },
    clickGetCategory(id) {
        this.subcategory = this.subcategoryMain.filter(item => item.parent_id == id )
    },
    clickGetCategorySub(id) {
        this.subcategory_sub = this.subcategoryMain.filter(item => item.parent_id == id )
    },
    
    hoverCategoryBlock() {
        let mcb = document.querySelector('.menu__subcategory')
        mcb.style.display = 'block'
    },
    hoverCategoryNone() {
        let mcb = document.querySelector('.menu__subcategory')
        mcb.style.display = 'none'
    },
    categoryIdOpen(id) {
        this.$router.push({ name: 'FilterCategory', params: { id: id }})
        this.$upd.$emit('updatefiltercategory')
        this.categoryShow = false
    },
    view_seacrh_block() {
        this.view_seacrh_bl = true
    }
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  mounted() {
    this.getCategory()  
  },
  computed: {
      ...mapGetters(['CART', 'FAVORITE', 'USER'])
  }
}
</script>
<style scoped lang="less">
 .v-expansion-panel-header {
    padding: 5px 21px;
 }
@baseMedia: 900px;
.select {
    position: fixed;
    top: 0;
    z-index: 999;
}
#header {
    width: 100%;
    background: #680;
    
    .header__margin {
        width: 95%;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        
        .menu_fixed_category {
            width: 100%;
            height: 100%;
            position: fixed;
            top: 0;
            z-index: 9999;
            background: #fff;
            left: 0;
            overflow-y: scroll;
            .row {
                width: 102%;
            }
            .cat_title_cl {
                width: 100%;
                background: #680;
                color: #fff;
                padding-left: 10px;
                text-align: left;
                height: 40px;
                display: flex;
                align-items: center;
                &:hover {
                    background: #465d01;
                    cursor: pointer;
                }
            }
            .mob_accordion_list {
                width: 100%;
                padding: 5px;
                background: #680;
                margin-bottom: 2px;
                &:hover {
                    background: #465d01;
                    cursor: pointer;
                }
                p {
                    color: white;
                }
            }
            .menu_fixed_category_header {
                width: 100%;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                background: #680;
                button {
                    width: 50px;
                    height: 50px;
                    span {
                        font-size: 20px;
                        color: #fff;
                    }
                    &:hover {
                        opacity: 0.7;
                    }
                }
                p {
                    color: #fff;
                    font-weight: bold;
                    font-size: 20px;
                }
            }
        }
        .search_view {
            width: 100%;
            position: relative;
            padding-top: 2px;
            padding-bottom: 2px;
        }
        .header_catalog {
            padding: 10px 7px;
            display: flex;
            justify-content: space-between;
            cursor: pointer;
            background: #76941a;
            align-items: center;
            &:hover{
                background:#557102;
            }
            p {
                font-size: 16px;
                color: #fff;
                margin-left: 5px;
            }
            span {
                color: #fff;
                font-size: 16px;
            }
        }
        .header__margin__r {
            width: 20%;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .header__r__m__user {
                display: flex;
                justify-content: flex-end;
                .h__r__m__u__b {
                    width: 50px;
                    height: 50px;
                    background: #76941a;
                    display: flex;
                    justify-content: center;
                    position: relative;
                    align-items: center;
                    margin: 1px;
                    @media (max-width: @baseMedia) {
                        width: 35px;
                        height: 35px;
                    }
                    .product__length {
                        width: 24px;
                        height: 24px;
                        border-radius: 50%;
                        background: red;
                        color: #fff;
                        font-size: 12px;
                        font-weight: bold;
                        position: absolute;
                        top: -2px;
                        text-align: center;
                        line-height: 24px;
                        right: -3px;  
                        @media (max-width: @baseMedia) {
                            width: 20px;
                            height: 20px;
                            font-size: 8px;
                            line-height: 20px;
                        }
                    }
                    &:hover {
                        opacity: 0.7;
                    }
                    cursor: pointer;
                    span {
                        color: #fff;
                        font-size: 30px;
                        @media (max-width: @baseMedia) {
                            font-size: 17px;
                        }
                    }
                }
            }
        }
    }
}



</style>
